import React from 'react';
import { GitHubComment, GitHubDiffHunkLine } from '../../domain/types';
import { Pill, Avatar } from '../../ui/common';

export interface GitHubCommentsSectionProps {
  itemId: string;
  comments?: GitHubComment[];
  onToggleCommentState: (itemId: string, commentIndex: number) => void;
}

export const GitHubCommentsSection: React.FC<GitHubCommentsSectionProps> = ({
  itemId,
  comments = [],
  onToggleCommentState,
}) => {
  if (!comments || comments.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {comments.map((comment, cIdx) => {
        const isResolved =
          comment.state === 'Resuelto' || comment.state === 'Aprobado' || comment.resolved;
        const fileLabel =
          comment.path && comment.line
            ? `${comment.path} L${comment.line}`
            : comment.path || 'comentario';

        return (
          <div
            key={comment.id || cIdx}
            onClick={(e) => {
              e.stopPropagation();
              onToggleCommentState(itemId, cIdx);
            }}
            style={{
              padding: '9px 11px',
              borderRadius: 10,
              background: 'var(--z-plate)',
              border: 'none',
              cursor: comment.state === 'Aprobado' ? 'default' : 'pointer',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 4 }}>
              <Avatar
                initials={comment.user.initials || 'US'}
                color={comment.user.color || 'var(--z-muted)'}
                size={21}
              />
              <span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--z-text-2)' }}>
                {comment.user.name || comment.user.login}
              </span>
              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: 'var(--z-faint)' }}>
                {fileLabel}
              </span>
              <span style={{ marginLeft: 'auto' }}>
                <Pill
                  label={comment.state || (isResolved ? 'Resuelto' : 'Sin resolver')}
                  tone={isResolved ? 'ok' : 'warn'}
                />
              </span>
            </div>
            {comment.diffHunk && (
              <div
                style={{
                  margin: '6px 0',
                  padding: '6px 8px',
                  borderRadius: 6,
                  background: 'var(--z-fill-2)',
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: 11,
                  overflowX: 'auto',
                }}
              >
                {comment.diffHunk.map((d: GitHubDiffHunkLine, dIdx: number) => (
                  <div
                    key={dIdx}
                    style={{
                      color:
                        d.type === 'add'
                          ? 'var(--z-ok-ink)'
                          : d.type === 'del'
                            ? 'var(--z-bad-ink)'
                            : 'var(--z-muted)',
                    }}
                  >
                    {d.content}
                  </div>
                ))}
              </div>
            )}
            <p
              style={{
                margin: 0,
                fontSize: 12,
                lineHeight: 1.5,
                color: 'var(--z-muted)',
                textWrap: 'pretty',
              }}
            >
              {comment.body}
            </p>
          </div>
        );
      })}
    </div>
  );
};
